export const FC_CONTENT = {
  hero: {
    kicker: 'Para donos de empresa e gestores financeiros',
    title: 'Chega de gerir o financeiro da empresa no Excel.',
    subtitle:
      'Você merece saber o saldo real agora, não no fim do mês. Com o 77Gestão, fluxo de caixa, contas e cobranças ficam em um único painel — simples, atualizado e confiável.',
    cta: 'Quero sair do Excel de vez',
    ctaMessage: 'Quero conhecer o controle financeiro do 77Gestão',
    urgency: 'Cada planilha a mais é um risco a mais. Quando foi a última vez que você confiou 100% nos seus números?',
  },

  statsStrip: [
    { number: '60h', label: 'economizadas por mês', icon: 'fa-regular fa-clock' },
    { number: '100%', label: 'visibilidade do fluxo de caixa', icon: 'fa-solid fa-eye' },
    { number: '1 clique', label: 'para emitir boleto', icon: 'fa-solid fa-file-invoice-dollar' },
  ],

  pain: {
    title: 'Reconhece algum desses cenários? Então você sabe que algo precisa mudar.',
    intro:
      'Milhares de empresas saudáveis perdem dinheiro e tempo porque ainda controlam o financeiro em planilhas. Não é falta de esforço — é falta da ferramenta certa.',
    groups: [
      {
        label: 'No dia a dia da operação',
        icon: 'fa-solid fa-gears',
        items: [
          { icon: 'fa-solid fa-money-bill-wave', text: 'Fluxo de caixa montado toda semana do zero, no Excel ou no caderno.' },
          { icon: 'fa-solid fa-file-invoice-dollar', text: 'Contas a pagar e receber espalhadas entre e-mails, WhatsApp e planilhas.' },
          { icon: 'fa-solid fa-rotate', text: 'Lançamentos duplicados porque mais de uma pessoa mexe nos números.' },
          { icon: 'fa-solid fa-triangle-exclamation', text: 'Boleto vencido, cobrança esquecida, cliente inadimplente sem que ninguém perceba a tempo.' },
          { icon: 'fa-solid fa-clock-rotate-left', text: 'Horas gastas todo mês para fechar o financeiro — que no fim sempre bate um "deu diferente".' },
        ],
      },
      {
        label: 'Na hora de tomar decisões',
        icon: 'fa-solid fa-chess',
        items: [
          { icon: 'fa-solid fa-chart-line', text: 'Sem visão diária do caixa: só percebe que o saldo apertou quando o extrato já fechou no vermelho.' },
          { icon: 'fa-solid fa-magnifying-glass-chart', text: 'Decisões de contratar, comprar ou investir tomadas no feeling, sem dados confiáveis.' },
          { icon: 'fa-solid fa-layer-group', text: 'Custos sempre no geral — sem saber qual área, produto ou cliente consome mais.' },
          { icon: 'fa-solid fa-chart-pie', text: 'DRE e relatórios que levam dias para ficar prontos e ainda assim geram dúvida.' },
          { icon: 'fa-solid fa-scale-unbalanced', text: 'Margem real desconhecida: você fatura, mas não sabe exatamente quanto sobra.' },
        ],
      },
    ],
  },

  midCta: {
    text: 'E se você pudesse abrir o sistema agora e ver tudo isso em um único painel?',
    cta: 'Quero ver na prática',
    ctaMessage: 'Quero ver uma demonstração do controle financeiro do 77Gestão',
  },

  solution: {
    title: 'Uma visão completa das finanças. Sem planilha, sem surpresa.',
    intro:
      'O módulo financeiro do 77Gestão foi desenhado para quem precisa de controle real — não de mais uma planilha para gerenciar.',
    cards: [
      {
        icon: 'fa-solid fa-money-bill-trend-up',
        title: 'Fluxo de caixa em tempo real',
        text: 'Veja entradas, saídas e saldo disponível atualizados automaticamente. Sem esperar o fim do mês para saber a situação.',
      },
      {
        icon: 'fa-solid fa-calendar-check',
        title: 'Contas a pagar e receber',
        text: 'Gerencie vencimentos, parcelas e pendências em um só lugar. Nunca mais esqueça um boleto ou uma cobrança.',
      },
      {
        icon: 'fa-solid fa-file-invoice-dollar',
        title: 'Emissão de boleto em 1 clique',
        text: 'Gere cobranças diretamente pelo sistema e receba mais rápido, sem depender de outro software ou do banco.',
      },
      {
        icon: 'fa-solid fa-file-invoice',
        title: 'Conciliação bancária automática (OFX)',
        text: 'Importe o extrato do banco e o sistema associa automaticamente cada lançamento, sem digitar tudo na mão nem torcer para não ter esquecido nada.',
      },
      {
        icon: 'fa-solid fa-layer-group',
        title: 'Centro de custo e categorias',
        text: 'Saiba exatamente onde o dinheiro vai: por área, produto, vendedor ou projeto. Margem real, sem achismos.',
      },
      {
        icon: 'fa-solid fa-hand-holding-dollar',
        title: 'Comissão de vendedores automática',
        text: 'Configure as regras uma vez e o sistema calcula tudo. Chega de discussão na hora do acerto.',
      },
    ],
  },

  proof: {
    title: 'O que acontece quando uma empresa sai do Excel para o 77Gestão',
    intro:
      'Uma empresa de Praia Grande com faturamento mensal na faixa de R$ 100k controlava tudo em planilhas. O sócio só sabia a situação real do caixa quando o contador fechava o mês.',
    stats: [
      { number: '60h', label: 'por mês economizadas em controles manuais' },
      { number: '3x', label: 'mais rápido para fechar o caixa do dia' },
      { number: '0', label: 'surpresas com saldo no final do mês' },
    ],
    paragraphs: [
      'Após a implantação, o fluxo de caixa passou a ser acompanhado diariamente — em qualquer dispositivo, sem precisar montar planilha nenhuma.',
      'O DRE por centro de custo mostrou, ainda no meio do trimestre, que uma linha de produto estava consumindo mais do que gerava. A empresa ajustou preço e fornecedor antes de fechar o período no vermelho.',
    ],
    highlight: 'Resultado: visibilidade real, decisões mais seguras e 60 horas por mês de volta para o que importa.',
    cta: 'Quero esse nível de controle',
    ctaMessage: 'Vi o case e quero entender como ter controle financeiro real no 77Gestão',
  },

  benefits: {
    title: 'Os três pilares que mudam a gestão financeira',
    items: [
      {
        icon: 'fa-solid fa-eye',
        title: 'Visibilidade',
        text: 'Saldo, fluxo de caixa, contas e indicadores disponíveis a qualquer momento — não só no fechamento do mês.',
      },
      {
        icon: 'fa-solid fa-sliders',
        title: 'Controle',
        text: 'Cada custo categorizado, cada cobrança rastreada. Você decide com base em dados, não em intuição.',
      },
      {
        icon: 'fa-solid fa-binoculars',
        title: 'Previsibilidade',
        text: 'DRE por período e por centro de custo mostra onde a margem aperta antes do fechamento do mês.',
      },
    ],
  },

  differentials: {
    title: 'Por que empresas escolhem o 77Gestão para sair do Excel',
    items: [
      {
        icon: 'fa-solid fa-puzzle-piece',
        title: 'Tudo integrado em um lugar só',
        text: 'Financeiro, estoque, vendas e NF-e conectados. Um lançamento alimenta tudo — sem retrabalho, sem inconsistência.',
      },
      {
        icon: 'fa-solid fa-handshake',
        title: 'Implantação acompanhada',
        text: 'Você não começa sozinho. A equipe configura junto com você, no seu ritmo, sem parar a operação.',
      },
      {
        icon: 'fa-solid fa-headset',
        title: 'Suporte humano e próximo',
        text: 'Atendimento real, sem ticket de fila. Quem responde conhece o sistema e entende o seu contexto.',
      },
      {
        icon: 'fa-solid fa-arrow-trend-up',
        title: 'Cresce com a sua empresa',
        text: 'Funciona bem para quem está começando e continua funcionando à medida que a operação cresce e fica mais complexa.',
      },
    ],
  },

  faq: {
    title: 'Dúvidas antes de agendar',
    items: [
      {
        question: 'Funciona para empresa com múltiplas contas bancárias?',
        answer:
          'Sim. Você cadastra todas as contas e o sistema consolida o saldo e o fluxo de caixa em uma visão única.',
      },
      {
        question: 'Precisa integrar com meu contador?',
        answer:
          'O sistema gera relatórios e exportações que facilitam o trabalho do contador. A integração depende do seu fluxo, mas já é compatível com os formatos mais usados.',
      },
      {
        question: 'Quanto tempo leva para implantar?',
        answer:
          'A implantação é acompanhada e feita em etapas. A maioria dos clientes começa a usar o financeiro em operação real nas primeiras semanas.',
      },
      {
        question: 'Funciona para qualquer tipo de empresa?',
        answer:
          'Sim. O módulo financeiro atende bem empresas de comércio, serviços e indústria leve. É mais indicado para negócios com faturamento mensal entre R$ 80k e R$ 500k que querem sair do Excel com segurança.',
      },
    ],
  },

  ctaFinal: {
    title: 'A planilha funcionou até aqui. Mas ela tem um limite — e você já chegou nele.',
    subtitle:
      'Agende uma demonstração gratuita e veja como é gerir o financeiro com clareza, sem depender de Excel, sem retrabalho e sem surpresa no saldo.',
    cta: 'Agendar demonstração gratuita',
    ctaMessage: 'Quero agendar uma demonstração do módulo financeiro do 77Gestão',
  },

  seo: {
    title: 'Sistema de Controle Financeiro para Empresas | 77Gestão',
    description:
      'Saia do Excel e tenha controle financeiro real: fluxo de caixa em tempo real, contas a pagar e receber, conciliação bancária e emissão de boletos em um único sistema. Implantação acompanhada.',
  },
};
